import config from "../config";
import axios from "axios";
import {result} from "lodash/object";

const BASE_URL = `${config.apiUrl}/campaign`;

export default {
    index() {
        return axios.get(`${BASE_URL}`).then(result => result.data);
    },
    store(data) {
        return axios.post(`${BASE_URL}`, data).then(result => result.data);
    },
    show(id) {
        return axios.get(`${BASE_URL}/${id}`).then(result => result.data);
    },
    destroy(id) {
        return axios.delete(`${BASE_URL}/${id}`).then(result => result.data);
    }
}
